import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_MY_COUPON } from "queries/queries";
import { useLocation } from "react-router-dom";
import backArrow from '../../assets/images/left_arrow.png';
import info from "../../assets/images/info.svg";
import closeIcon from "../../assets/images/close_icon.png";
import { useHistory } from "react-router-dom";

const MyCouponCampaignDetail = ({ }) => {
  const location = useLocation()
  const campaign = location.state?.campaign;

  const { data } = useQuery(GET_MY_COUPON, {
    variables: { campaignId: campaign?.id || '' },
    fetchPolicy: "no-cache",
    skip: !campaign,
  });

  const history = useHistory();

  const [showRules, setShowRules] = useState(false);
  useEffect(() => {
    if (!showRules) return;
    const onKey = (e) => e.key === "Escape" && setShowRules(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [showRules]);

  const handleBack = () => {
    history.push("/coupons-list");
  };

  const withoutTime = { year: "2-digit", month: "2-digit", day: "2-digit" }

  useEffect(() => {
    const wrapper = document.querySelector(".scrollable");
    if (!wrapper) return;

    document.querySelector(".scrollable").addEventListener(
      "touchmove",
      function(event) {
        event.stopPropagation();
      },
      false
    );
  });

  if (!campaign) {
    return <div>Campaign details not available.</div>;
  }

  if (!data) {
    return <div>Campaign details not available.</div>;
  }

  return (
      <div className="campaign-details-content campaign-details-my scrollable">
        <img 
          src={backArrow} 
          alt="back" 
          className="points-header-arrow" 
          onClick={handleBack} 
        />
        <img 
          src={campaign.coverImageUrl} 
          className="campaign-details-image"
        />
        <div>
          <div className="campaign-details-info">
            <div className="campaign-details">
              <div className="campaign-details-supplier">{campaign.supplier}</div>
              <div className="campaign-details-expires">Gültig Bis: {new Date(campaign.expiresAt.split(' ')[0].replace(/-/g, "/")).toLocaleDateString("de", withoutTime)}</div>
            </div>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <div className="campaign-details-title">{campaign.title}</div>
              <img
                src={info}
                alt="Teilnahmebedingungen"
                role="button"
                tabIndex={0}
                onClick={() => setShowRules(true)}
                onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && setShowRules(true)}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
          {data.myCoupons?.[0]?.code && (
            <div className="points-container">
              <div className="campaign-details-code">
                {data.myCoupons[0].code}
              </div>
            </div>
          )}
          <div className="campaign-description"
          dangerouslySetInnerHTML={{ __html: campaign.description }}
          >
          </div>
        </div>

        {showRules && (
          <div
            className="modal-overlay"
            onClick={() => setShowRules(false)}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.45)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
            aria-modal="true"
            role="dialog"
          >
            <div
              className="modal-card"
              onClick={(e) => e.stopPropagation()}
              style={{
                maxHeight: "80vh",
                overflowY: "auto",
                background: "#fff",
                borderRadius: 16,
                boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                padding: 20,
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                <div style={{ fontWeight: 700, fontSize: 18 }}>Teilnahmebedingungen</div>
                <button
                  onClick={() => setShowRules(false)}
                  aria-label="Schließen"
                  style={{
                    border: "none",
                    background: "transparent",
                    fontSize: 20,
                    cursor: "pointer",
                    lineHeight: 1,
                    padding: 0,
                  }}
                >
                  <img src={closeIcon} alt="Close" style={{ width: '20px'}}/>
                </button>
              </div>

              <div style={{ marginTop: 12, color: "#4d4d4d", whiteSpace: "pre-wrap" }}>
                {campaign.participantRules || "Keine Teilnahmebedingungen verfügbar."}
              </div>
            </div>
          </div>
        )}
      </div>
  );
};
export default MyCouponCampaignDetail;